"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SyncLocationRefresh: ['sync-location-refresh', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.5,10.5c0,3.171,3.977,7.184,4.146,7.354a.5.5,0,0,0,.708,0c.169-.17,4.146-4.183,4.146-7.354a4.5,4.5,0,0,0-9,0Zm6,0A1.5,1.5,0,1,1,12,9,1.5,1.5,0,0,1,13.5,10.5Z', 'M5.407,11.887a.75.75,0,0,0-.656-.387H4.325a.5.5,0,0,1-.5-.565A8.243,8.243,0,0,1,18.471,6.882,1,1,0,1,0,20.039,5.64,10.242,10.242,0,0,0,1.807,11.047a.5.5,0,0,1-.5.453H.75a.75.75,0,0,0-.636,1.147l2,3.2a.75.75,0,0,0,1.273,0l2-3.2A.75.75,0,0,0,5.407,11.887Z', 'M23.886,11.353l-2-3.2a.78.78,0,0,0-1.273,0l-2,3.2a.75.75,0,0,0,.636,1.147h.426a.5.5,0,0,1,.5.565A8.243,8.243,0,0,1,5.529,17.118,1,1,0,1,0,3.961,18.36a10.242,10.242,0,0,0,18.232-5.407.5.5,0,0,1,.5-.453h.56a.75.75,0,0,0,.636-1.147Z']],
  SyncLocation: ['sync-location', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20.607,11.458a.959.959,0,1,0-.894,1.7c1.5.792,2.367,1.775,2.367,2.7,0,1.821-3.148,3.6-7.323,4.14a.96.96,0,0,0,.122,1.912c.04,0,.083,0,.124-.007,5.381-.7,9-3.125,9-6.045C24,14.17,22.8,12.608,20.607,11.458Z', 'M10.419,18.875a.48.48,0,0,0-.819.34v.653c0,.173-.121.162-.181.155-4.663-.555-7.5-2.51-7.5-4.168,0-.924.863-1.907,2.367-2.7a.959.959,0,0,0-.894-1.7C1.205,12.608,0,14.17,0,15.855c0,3,3.875,5.476,9.363,6.091a.247.247,0,0,1,.237.248v.861a.479.479,0,0,0,.3.443.9.9,0,0,0,.523-.1l1.92-1.92a.479.479,0,0,0,0-.679Z', 'M12,.5a6.247,6.247,0,0,0-6.24,6.24c0,2.757,3.829,8.155,5.476,10.348a.952.952,0,0,0,1.528,0C14.411,14.89,18.24,9.492,18.24,6.735A6.247,6.247,0,0,0,12,.5Zm0,8.64a2.4,2.4,0,1,1,2.4-2.4A2.4,2.4,0,0,1,12,9.135Z']]
};
exports["default"] = _default;